import {useStyles} from '../../shared/hooks/styles';
import {AlignFunc} from '../../shared/theme/helpers';
import {Theme} from '../../shared/theme/interface';

const paperBorderRadius = 8;

export const GetStyles = (align: AlignFunc, theme: Theme) => {
  return useStyles(({addShadow}) => ({
    campusMembershipWrapper: {
      ...addShadow({
        height: 3,
        radius: 3,
        opacity: 0.12,
      }),
      borderRadius: align(8),
      marginBottom: align(30),
      width: align(290),
      backgroundColor: theme.campus.cardBackgroundColor,
      borderStyle: 'solid',
      borderColor: theme.color.whiteTextColor,
      borderWidth: 1,
    },
    barcodeWrapper: {
      overflow: 'hidden',
      ...addShadow({
        height: 2,
        radius: 18,
        opacity: 0.25,
      }),
      borderRadius: align(8),
      marginBottom: align(30),
      width: align(290),
    },
    cardNumberTitle: {
      ...theme.fonts.label,
      marginBottom: 4,
    },
    cardNumberContainer: {
      overflow: 'hidden',
      ...addShadow({
        height: 2,
        radius: 18,
        opacity: 0.1,
      }),
      height: 70,
      backgroundColor: theme.color.primaryNonGreyBackground,
      width: align(290),
      paddingTop: 7,
      paddingBottom: 20,
      justifyContent: 'center',
      paddingHorizontal: 12,
      borderRadius: align(paperBorderRadius),
    },
    cardNumberText: {
      ...theme.fonts.h5,
      color: theme.color.textColor,
      textAlign: 'center',
    },
    screen: {flex: 1},
    scroll: {flex: 1},
    container: {
      maxHeight: '100%',
      backgroundColor: theme.color.primaryNonGreyBackground,
      borderTopLeftRadius: 16,
      borderTopRightRadius: 16,
    },
    innerContainer: {
      marginLeft: 'auto',
      marginRight: 'auto',
      marginBottom: 32,
    },
    barcode: {
      paddingBottom: align(30),
    },
    modal: {
      justifyContent: 'flex-end',
      margin: 0,
    },
    closeButton: {
      marginLeft: 'auto',
      marginRight: 'auto',
      marginTop: 10,
      marginBottom: 17,
    },
  }));
};
